// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import DefaultModal, { DefaultModalProps } from './DefaultModal';

// Constants and types
import { MODAL_SIZES } from '@/utils/constants';

const WarningModal = ({ title, className, ...rest }: DefaultModalProps) => {
  const icon = <i className="icon-ds-warning-amber" />;
  const titleWithIcon = (
    <span>
      {icon}
      {title}
    </span>
  );
  return <DefaultModal className={classNames('modal-warning', className)} isWarning title={titleWithIcon} size={MODAL_SIZES.SM} {...rest} />;
};

export default WarningModal;
